/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TrackElementWrite } from './TrackElementWrite';
import {
    TrackElementWriteFromJSON,
    TrackElementWriteFromJSONTyped,
    TrackElementWriteToJSON,
} from './TrackElementWrite';

/**
 * 
 * @export
 * @interface RemixParentWrite
 */
export interface RemixParentWrite {
    /**
     * 
     * @type {Array<TrackElementWrite>}
     * @memberof RemixParentWrite
     */
    tracks: Array<TrackElementWrite>;
}

/**
 * Check if a given object implements the RemixParentWrite interface.
 */
export function instanceOfRemixParentWrite(value: object): value is RemixParentWrite {
    let isInstance = true;
    isInstance = isInstance && "tracks" in value && value["tracks"] !== undefined;

    return isInstance;
}

export function RemixParentWriteFromJSON(json: any): RemixParentWrite {
    return RemixParentWriteFromJSONTyped(json, false);
}

export function RemixParentWriteFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemixParentWrite {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tracks': ((json['tracks'] as Array<any>).map(TrackElementWriteFromJSON)),
    };
}

export function RemixParentWriteToJSON(value?: RemixParentWrite | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tracks': ((value.tracks as Array<any>).map(TrackElementWriteToJSON)),
    };
}

